import certified from "../../Assets/Images/certified.png"
import appointment from "../../Assets/Images/appointment.png"
import convenient from "../../Assets/Images/convenient.png"
import instrumentation from "../../Assets/Images/instrumentation.png"

export const CardData=[
    {
        title:"Certified",
        subtitle:<>
            There are different levels of training when it comes to providers of breathing services.  Clients can be assured that CapnoLearning<sup style={{ fontSize: "8px" }}>TM</sup> certification means providers are certified through an accredited higher education program.  The technician certification in CapnoLearning<sup style={{ fontSize: "8px" }}>TM</sup> includes training to identify carbon dioxide (CO<sub>2</sub>) deficits brought about by breathing habits that disrupt respiration. CapnoLearning<sup style={{ fontSize: "8px" }}>TM</sup> services bring together respiratory physiology, CO<sub>2</sub> technology, and behavioral science to help with coaching clients as they learn strategies that can optimize respiration and improve health and performance.
        </>,
        icon:certified
    },
    {
        title:"Appointments",
        subtitle:<>
            Interested in CapnoLearning<sup style={{ fontSize: "8px" }}>TM</sup> services? To learn more about your breathing habits and the effects get started by clicking on the “inquiry” button located on the “individual services” page. During an initial appointment learn more about the relationship of breathing habits and respiration pertaining to challenges you experience in health and performance relevant to you. We will also discuss CapnoLearning<sup style={{ fontSize: "8px" }}>TM</sup>  service options specific to improving breathing habits and the role in respiration, including the instrumentation we specify and coaching appointments.
        </>,
        icon:appointment
    },
    {
        title:"Instrumentation",
        subtitle:<>
           Instrumentation is provided during coaching appointments and assists with identifying problematic breathing habits and improving them when learning to optimize respiration in real-time. The instrumentation is a combination of hardware and software and fits inside most clothing pockets, is lightweight, and can operate with USB or Bluetooth and is Apple and PC compatible.
        </>,
        icon:instrumentation
    },
    {
        title:"Convenient",
        subtitle:<>
            The initial inquiry is conducted by phone or webinar. Subsequent sessions can include one-on-one coaching and instrumentation options to promote learning breathing habits that can optimize respiration from within your daily life. After the initial inquiry and when you choose additional CapnoLearning<sup style={{ fontSize: "8px" }}>TM</sup> services,  please be able to provide and operate your own computer with email, high speed internet, phone number, and be able to download software onto your computer.


        </>,
        icon:convenient
    },
]